import {isFeatureEnabled} from '@github-ui/feature-flags'
import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerNavigatorApp} from '@github-ui/react-core/register-app'

import {App} from './App'

import {BoomTown} from './routes/BoomTown'
import {DiversityIndex} from './routes/about/diversity/DiversityIndex'
import {Home} from './routes/home/Index'
import {ShowPage} from './routes/ShowPage'
import {ThankYouPage} from './routes/ThankYouPage'
import EventsUniverseRecapIndex from './routes/events/universe/recap/Index'
import FeaturesCopilotPlansIndex from './routes/features/copilot/plans/Index'
import FeaturesCopilotAiCodeEditorIndex from './routes/features/copilot/ai-code-editor/Index'
import SecurityPlansIndex from './routes/security/plans/Index'
import {GitHubAppGAPage} from './routes/features/ai/github-app/Index'

registerNavigatorApp('landing-pages', () => {
  return {
    App,
    routes: [
      // Only claim the legacy routes while the backend continues to serve their legacy payloads.
      ...(isFeatureEnabled('flex_suite_details')
        ? []
        : [
            jsonRoute({path: '/about/diversity', Component: DiversityIndex}),
            jsonRoute({path: '/features/copilot/ai-code-editor', Component: FeaturesCopilotAiCodeEditorIndex}),
          ]),
      jsonRoute({path: '/contact-sales/thank-you', Component: ThankYouPage}),
      jsonRoute({path: '/enterprise/contact/thanks', Component: ThankYouPage}),
      jsonRoute({path: '/events/universe/recap', Component: EventsUniverseRecapIndex}),
      jsonRoute({path: '/features/ai/github-app', Component: GitHubAppGAPage}),
      jsonRoute({path: '/features/copilot/plans', Component: FeaturesCopilotPlansIndex}),
      jsonRoute({path: '/home', Component: Home}),
      jsonRoute({path: '/security/plans', Component: SecurityPlansIndex}),

      /**
       * We use this route to exercise error handling and exception reporting.
       * in the app. The BoomTown component simply throws an error when it renders.
       */
      jsonRoute({path: '/contentful-lp-tests/boomtown', Component: BoomTown}),

      jsonRoute({path: '*', Component: ShowPage}),
    ],
  }
})
